import { addIcons } from "oh-vue-icons"

import {
  // Used icons only
  BiCheck,
  BiCheckCircle,
  BiCheckLg,
  BiCalendar3,
  BiCardImage,
  BiInfoCircle,
  BiShieldLock,
  CoClock,
  CoTelegramPlane,
  CoWarning,
  HiArrowSmRight,
  HiClipboardCopy,
  HiCursorClick,
  HiDocumentAdd,
  HiEye,
  HiPlusSm,
  HiViewGrid,
  IoClose,
  LaEditSolid,
  MdAttachmoneyRound,
  MdContentcopyRound,
  MdDangerousOutlined,
  MdFilteraltOutlined,
  MdFirstpageRound,
  MdFormatlistbulletedRound,
  MdLastpageRound,
  MdLocationonOutlined,
  MdMonetizationonRound,
  MdNavigatebeforeRound,
  MdNavigatenextRound,
  MdOpeninnewRound,
  MdPeopleRound,
  MdTableviewOutlined,
  MdWarningRound,
  RiCoinsLine,
  RiLoader5Line,
  SiMicrosoftteams,
  MdViewcolumn,
  // Featured campaign icon
  HiSolidBadgeCheck,
  // Export icons
  HiDownload,
  BiBraces,
} from "oh-vue-icons/icons"

/**
 * Register all icons used throughout the application
 * This centralizes icon management and keeps main.js clean
 */
export function registerIcons() {
  addIcons(
    // Warning and status icons
    MdWarningRound,
    MdViewcolumn,
    MdPeopleRound,
    MdMonetizationonRound,
    MdContentcopyRound,
    MdDangerousOutlined,
    BiInfoCircle,
    CoWarning,
    CoClock,
    BiCheckCircle,
    BiCheck,
    BiCheckLg,
    RiLoader5Line,
    // Dashboard stat card icons
    HiEye,
    HiCursorClick,
    RiCoinsLine,
    
    // Interface and action icons
    HiViewGrid,
    MdFormatlistbulletedRound,
    BiCardImage,
    HiDocumentAdd,
    BiShieldLock,
    HiClipboardCopy,
    HiPlusSm,
    LaEditSolid,
    IoClose,
    MdOpeninnewRound,
    
    // Navigation and pagination icons
    MdLastpageRound,
    MdNavigatenextRound,
    MdNavigatebeforeRound,
    MdFirstpageRound,
    HiArrowSmRight,
    
    // Filter and location icons
    MdFilteraltOutlined,
    MdAttachmoneyRound,
    MdLocationonOutlined,
    
    // Calendar icons
    BiCalendar3,
    
    // Communication icons
    SiMicrosoftteams,
    CoTelegramPlane,
    
    // Featured campaign icon
    HiSolidBadgeCheck,
    
    // Export functionality icons
    HiDownload,
    BiBraces,
    MdTableviewOutlined,
  )
}